import React, { useRef } from 'react';
import { Page } from 'react-pdf';

type PdfPagesProps = {
    pages: number;
    page: number;
    scale: number;
    pdfWidth: number;
    rotate: number;
    isVerticalScroll: boolean;
    isResponsive: boolean;
};

const PdfPages: React.FunctionComponent<PdfPagesProps> = ({
    pages,
    page,
    scale,
    pdfWidth,
    rotate,
    isVerticalScroll,
    isResponsive,
}) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    // Set width and heigth to 100% is Pdf isResponsive
    const handleRenderSuccess = () => {
        if (isResponsive && canvasRef.current) {
            canvasRef.current.style.setProperty('width', `${100 * scale}%`);
            canvasRef.current.style.setProperty('height', 'auto');
        }
    };

    // Number of pages of the documents transform as array in order to display all the pages in isVerticalScroll mode
    // Or only the current page if isVerticalScroll is false
    const pageNumbers =
        isVerticalScroll && pages > 0 ? Array.from({ length: pages }, (_, i) => i + 1) : [page];

    return pageNumbers.map((nbr) => (
        <Page
            key={nbr}
            pageNumber={nbr}
            scale={scale}
            width={pdfWidth}
            rotate={rotate}
            canvasRef={canvasRef}
            onRenderSuccess={() => handleRenderSuccess()}
        />
    ));
};

export default PdfPages;
